<div class="item" [class.disabled]="disabled"><img *ngIf="icon" [appIcon]="icon" /> {{ label | appTranslate }}</div>
